export default __webpack_public_path__ + "static/media/relogio.3f3e4c9b.svg";